(function(){
  var params=new URLSearchParams(window.location.search);
  var handle=params.get('product');
  var note=document.getElementById('note');
  var error=document.getElementById('error');
  var shareButton=document.getElementById('share-button');

  document.getElementById('print-button').addEventListener('click',function(){window.print()});

  if(navigator.share){
    shareButton.addEventListener('click',function(){
      navigator.share({title:document.title,url:window.location.href}).catch(function(){});
    });
  }else{
    shareButton.addEventListener('click',function(){
      if(navigator.clipboard){navigator.clipboard.writeText(window.location.href).then(function(){shareButton.textContent='Link copied'});}
    });
  }

  function normaliseHeading(text){
    return (text||'').trim().toLowerCase().replace(/&/g,'and').replace(/\s+/g,' ');
  }

  function sectionMap(container){
    var map={}, current=null;
    Array.prototype.forEach.call(container.children,function(node){
      if(node.tagName==='H3'){
        current=normaliseHeading(node.textContent);
        if(!map[current]) map[current]=[];
      }else if(current){
        map[current].push(node.outerHTML);
      }
    });
    return map;
  }

  function put(id,sectionId,html){
    if(!html||!html.trim()){document.getElementById(sectionId).classList.add('hidden');return}
    document.getElementById(id).innerHTML=html;
  }

  function parseGlance(html){
    var holder=document.createElement('div');
    holder.innerHTML=(html||'').replace(/<br\s*\/?>/gi,'\n').replace(/<\/p>/gi,'\n');
    return (holder.textContent||'').split(/\n+/).map(function(line){
      var idx=line.indexOf(':');
      return idx>0?{label:line.slice(0,idx).trim(),value:line.slice(idx+1).trim()}:null;
    }).filter(function(item){return item && !/shelf\s*life/i.test(item.label)});
  }

  function renderGlance(items){
    if(!items.length){document.getElementById('section-glance').classList.add('hidden');return}
    var tbody=document.getElementById('glance'), by={};
    items.forEach(function(x){by[x.label.toLowerCase()]=x.value});
    var meta=[];
    ['origin','milk','style','age'].forEach(function(k){if(by[k])meta.push(by[k])});
    document.getElementById('note-meta').textContent=meta.join(' · ');
    for(var i=0;i<items.length;i+=2){
      var tr=document.createElement('tr');
      [items[i],items[i+1]].forEach(function(item){
        var td=document.createElement('td');
        if(item){var label=document.createElement('strong');label.textContent=item.label+': ';td.appendChild(label);td.appendChild(document.createTextNode(item.value))}
        tr.appendChild(td);
      });
      tbody.appendChild(tr);
    }
  }

  if(!handle){error.hidden=false;return}

  Promise.all([
    fetch('/products/'+encodeURIComponent(handle)+'.js',{credentials:'same-origin'}).then(function(res){if(!res.ok)throw new Error('Product not found');return res.json()}),
    fetch(document.getElementById('print-note-script').dataset.notesUrl).then(function(res){if(!res.ok)throw new Error('Notes unavailable');return res.json()})
  ])
    .then(function(results){
      var product=results[0],curated=results[1].notes[handle];
      document.title=product.title+' Tasting Note | K-SEIN Fromagerie';
      document.getElementById('note-title').textContent=product.title;
      if(curated){
        put('description','section-description',curated.description);
        renderGlance(Object.keys(curated.specs).map(function(label){return {label:label,value:curated.specs[label]}}));
        ['taste','serve','drink','pair','more'].forEach(function(key){put(key,'section-'+key,curated[key])});
        document.getElementById('method-note').hidden=false;
      }else{
        var split=(product.description||'').split('<!-- split -->');
        put('description','section-description',split[0]||'');
        var holder=document.createElement('div');
        holder.innerHTML=split.slice(1).join('<!-- split -->')||'';
        var sections=sectionMap(holder);
        renderGlance(parseGlance((sections['at a glance']||[]).join('')));
        put('taste','section-taste',(sections['taste and texture']||[]).join(''));
        put('serve','section-serve',(sections['how to serve it']||sections['how to use it']||[]).join(''));
        put('drink','section-drink',(sections['what to drink with it']||[]).join(''));
        put('pair','section-pair',(sections['pair it with']||[]).join(''));
        put('more','section-more',(sections['want to know a little more?']||sections['want to know a little more']||[]).join(''));
      }
      note.hidden=false;
      document.getElementById('print-button').disabled=false;
    })
    .catch(function(){error.hidden=false});
})();
